/**
 * Resolve contact ids from a bulk-action `selected` array.
 *
 * The AddToJob / AddToProject bulk actions are invoked from several places, each
 * passing `selected` in a different shape:
 *   - Contacts page: items ARE contacts            → contact id is `item.id`
 *   - Job candidates page: items are applications  → contact id is `item.contact.id`
 *   - Flows / Projects bulk-action bars: items are react-table rows ({ original })
 *     whose `original` is the contact/application → contact id is `original.id`
 *
 * Reading `item.id` directly on a react-table row yields the *row* id, not the
 * contact id — which is the bug that sends incorrect `contact_ids` to the server.
 * Unwrapping `original` first handles all shapes uniformly.
 */
export const resolveContactId = (item: any): string | number | undefined => {
  const record = item?.original ?? item;
  return record?.contact?.id || record?.id;
};

export const resolveSelectedContactIds = (
  selected: any[]
): Array<string | number> =>
  (selected ?? []).map(resolveContactId).filter(Boolean) as Array<
    string | number
  >;
